import numeral from "numeral";

export const CurrencyCell = ({ value }) => {
  const n = numeral(value ?? null);
  if (n.value() === null) return null;
  return n.format("0,0.00");
};
